import FileUploadItem from './file-upload-item.element.js';

export default FileUploadItem;

FileUploadItem.define('wje-file-upload-item', FileUploadItem);
